import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';

export const NativeCollabLoader = LoadablePaint({
	name: MustPreloadLoadableNames.NativeCollabLoader,
	loader: async () => {
		const { NativeCollabComponent } = await import(
			/* webpackChunkName: "loadable-NativeCollabComponent" */ '../src/NativeCollabComponent'
		);
		return NativeCollabComponent;
	},
});
